export default __webpack_public_path__ + "static/media/Logo-Login@2x.e267671a.png";